import Vue from 'vue'
import VueRouter from 'vue-router'
import{addBack,remveBack,cancel} from '../clue/back.js'
// import login from '@/components/login'
// import identityCheck from '@/view/identityCheck'
// import mine from '@/view/mine'
// import daySign from "@/view/daySign/daySign";//个人日签
//------------ TC路由--------------//
//------------ TC路由--------------//
Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        name: 'content',
        component:  resolve => require(['@/components/content'], resolve),
        children: [
            {
                path: '/',
                name: 'homeN',
                components: {
                    default: resolve => require(['../view/homeN/index'], resolve),
                    // default: resolve => require(['../view/homeN/index2'], resolve),
                },
                meta: {
                    title: '首页',
                    // keepAlive: true, // 需要被缓存
                }
            },
            {
                path: '/myTeam',
                name: 'myTeam',
                components: {
                    default: resolve => require(['../view/myTeam/index'], resolve),
                },
                meta: {
                    title: '我的团队',
                    // keepAlive: true, // 需要被缓存
                }
            },
            {
                path: '/mine',
                name: 'mine',
                components: {
                    default: resolve => require(['../view/mine/index'], resolve),
                },
                meta: {
                    title: '个人中心',
                    // keepAlive: true, // 需要被缓存
                }
            },
            {
                path: '/productList',
                name: 'productList',//我的
                components: {
                    default: resolve => require(['../view/product/products'], resolve),
                },
                meta: {
                    title: '产品库',
                    // keepAlive: true, // 需要被缓存
                }
            },
        ],

    },
    {
        path: '/quoteInfo',
        name: 'quoteInfo',
        components: {
            default: resolve => require(['../view/quoteInfo'], resolve),
        },
        meta: {
            title: '报价信息',
            // keepAlive: true, // 需要被缓存
        }
    },
    // 金小二
    {
        path: '/sharedPayment',
        name: 'sharedPayment',
        components: {
            default: resolve => require(['../view/kingWaiter/sharedPayment'], resolve),
        },
        meta: {
            title: '共享办公缴费记录',
            // keepAlive: true, // 需要被缓存
        }
    },
    // {
    //     path: '/chooseSeat',
    //     name: 'chooseSeat',
    //     components: {
    //         default: resolve => require(['../view/kingWaiter/chooseSeat'], resolve),
    //     },
    //     meta: {
    //         title: '共享座位查询',
    //         // keepAlive: true, // 需要被缓存
    //     }
    // },
    // 金小二
    // 往下新界面
    {
        path: '/leaderboard',
        name: 'leaderboard',
        components: {
            default: resolve => require(['../view/homeN/leaderboard'], resolve),
        },
        meta: {
            title: '排行榜',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/search',
        name: 'search',
        components: {
            default: resolve => require(['../view/homeN/search'], resolve),
        },
        meta: {
            title: '产品搜索',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/browseHistory',
        name: 'browseHistory',
        components: {
            default: resolve => require(['../view/browseHistory/index'], resolve),
        },
        meta: {
            title: '浏览记录',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/teamRanking',
        name: 'teamRanking',
        components: {
            default: resolve => require(['../view/myTeam/teamRanking'], resolve),
        },
        meta: {
            title: '团队排行',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/littleShop',
        name: 'littleShop',
        components: {
            default: resolve => require(['../view/myLittleShop/index'], resolve),
        },
        meta: {
            title: '我的小店',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/myScores',
        name: 'index',
        components: {
            default: resolve => require(['../view/myScores/index'], resolve),
        },
        meta: {
            title: '我的积分',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/withdrawal',
        name: 'withdrawal',
        components: {
            default: resolve => require(['../view/myScores/withdrawal'], resolve),
        },
        meta: {
            title: '积分提现',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/consult',
        name: 'consult',
        components: {
            default: resolve => require(['../view/businessConsult/index'], resolve),
        },
        meta: {
            title: '业务咨询',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/addConsult',
        name: 'addConsult',
        components: {
            default: resolve => require(['../view/businessConsult/addConsult'], resolve),
        },
        meta: {
            title: '新增业务咨询',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/consultDetails',
        name: 'consultDetails',
        components: {
            default: resolve => require(['../view/businessConsult/consultDetails'], resolve),
        },
        meta: {
            title: '咨询详情',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/suggestions',
        name: 'suggestions',
        components: {
            default: resolve => require(['../view/suggestions/index'], resolve),
        },
        meta: {
            title: '投诉建议',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/addSuggest',
        name: 'addSuggest',
        components: {
            default: resolve => require(['../view/suggestions/addSuggest'], resolve),
        },
        meta: {
            title: '新增投诉建议',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/suggestDetails',
        name: 'suggestDetails',
        components: {
            default: resolve => require(['../view/suggestions/suggestDetails'], resolve),
        },
        meta: {
            title: '投诉建议详情',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/myVisitor',
        name: 'myVisitor',
        components: {
            default: resolve => require(['../view/myLittleShop/myVisitor'], resolve),
        },
        meta: {
            title: '我的访客',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/myOrder',
        name: 'indedx',
        components: {
            default: resolve => require(['../view/myOrder/index'], resolve),
        },
        meta: {
            title: '我的订单',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/addOrder',
        name: 'addOrder',
        components: {
            default: resolve => require(['../view/myOrder/addOrder'], resolve),
        },
        meta: {
            title: '新增订单',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/orderDetail',
        name: 'orderDetail',
        components: {
            default: resolve => require(['../view/myOrder/orderDetail'], resolve),
        },
        meta: {
            title: '保险订单',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/loanOrderDetail',
        name: 'loanOrderDetail',
        components: {
            default: resolve => require(['../view/myOrder/loanOrderDetail'], resolve),
        },
        meta: {
            title: '贷款订单',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/personalInfo',
        name: 'personalInfo',
        components: {
            default: resolve => require(['../view/personalInfo/index'], resolve),
        },
        meta: {
            title: '个人信息',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/myClient',
        name: 'myClient',
        components: {
            default: resolve => require(['../view/myClient/index'], resolve),
        },
        meta: {
            title: '我的客户',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/clientMaterial',
        name: 'clientMaterial',
        components: {
            default: resolve => require(['../view/myClient/clientMaterial'], resolve),
        },
        meta: {
            title: '客户资料',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/information',
        name: 'information',
        components: {
            default: resolve => require(['../view/information/index'], resolve),
        },
        meta: {
            title: '消息',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/activity',
        name: 'activity',
        components: {
            default: resolve => require(['../view/information/activity'], resolve),
        },
        meta: {
            title: '敬请期待',
            // keepAlive: true, // 需要被缓存
        }
    },

    // 往上新界面
    //
    {
        path: '/productListEdit',
        name: 'productListEdit',//我的
        components: {
            default: resolve => require(['../view/product/productsEdit'], resolve),
        },
        meta: {
            title: '编辑推荐产品',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/homePage',
        name: 'homePage',//首页
        components: {
            default: resolve => require(['../view/myHomePage/homePage'], resolve),
        },
        meta: {
            title: '我的主页',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/homePageB',
        name: 'homePageB',//首页
        components: {
            default: resolve => require(['../view/myHomePage/homePageB'], resolve),
        },
        meta: {
            title: '我的主页',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/visitFootprint',
        name: 'visitFootprint',//首页
        components: {
            default: resolve => require(['../view/myHomePage/visitFootprint'], resolve),
        },
        meta: {
            title: '访问足迹',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/information',
        name: 'information',
        components: {
            default: resolve => require(['../view/home/information'], resolve),
        },
        meta: {
            title: '消息',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/myInvitation',
        name: 'myInvitation',
        components: {
            default: resolve => require(['../view/mine/myInvitation'], resolve),
        },
        meta: {
            title: '邀请记录',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/dailyCheckIn',
        name: 'dailyCheck-in',
        components: {
            default: resolve => require(['../view/daySign/dailyCheck-in'], resolve),
        },
        meta: {
            title: '每日签到',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/businessCard',
        name: 'businessCard',//首页
        components: {
            default: resolve => require(['../view/mineBusinessCard/businessCard'], resolve),
        },
        meta: {
            title: '个人名片',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/businessCardTC',
        name: 'businessCard',//首页
        components: {
            default: resolve => require(['../view/mineBusinessCard/businessCardTC'], resolve),
        },
        meta: {
            title: '个人名片',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/withdraw',
        name: 'withdraw',//首页
        components: {
            default: resolve => require(['../view/mine/withdraw'], resolve),
        },
        meta: {
            title: '提现',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/accountSecurity',
        name: 'accountSecurity',
        components: {
            default: resolve => require(['../view/mine/accountSecurity'], resolve),
        },
        meta: {
            title: '账户安全',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/privacy',
        name: 'privacy',
        components: {
            default: resolve => require(['../view/mine/privacy'], resolve),
        },
        meta: {
            title: '隐私协议',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/userTxt',
        name: 'userTxt',
        components: {
            default: resolve => require(['../view/mine/userTxt'], resolve),
        },
        meta: {
            title: '用户协议',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/aboutUs',
        name: 'aboutUs',
        components: {
            default: resolve => require(['../view/mine/aboutUs'], resolve),
        },
        meta: {
            title: '关于我们',
            // keepAlive: true, // 需要被缓存
        }
    },  
    {
        path: '/collection',
        name: 'collection',
        components: {
            default: resolve => require(['../view/collection/index'], resolve),
        },
        meta: {
            title: '实名绑卡',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/editBank',
        name: 'editBank',
        components: {
            default: resolve => require(['../view/collection/editBank'], resolve),
        },
        meta: {
            title: '实名绑卡',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/taskection',
        name: 'taskection',
        components: {
            default: resolve => require(['../view/collection/taskection'], resolve),
        },
        meta: {
            title: '任务领取',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/contract',
        name: 'taskection',
        components: {
            default: resolve => require(['../view/collection/contract'], resolve),
        },
        meta: {
            title: '合同条款',
            // keepAlive: true, // 需要被缓存
        }
    },
    //
    {
        path: "/clueHome",
        name: "clueHome",
        components: {
          default: resolve => require(['../view/clueHome/home'], resolve),
        },
        meta:{
          title:"销售线索", //配置title
          keepAlive:true
        },
        // beforeEnter: (to, from, next) => {
        //     (from),
        //   // ...
        //    addBack()
        //     next()
        // },
      },
      {
        path: "/clueDetails",
        name: "clueDetails",
        components: {
          default: resolve => require(['../view/clueHome/clueDetails'], resolve),
        },
        meta:{
          title:"线索详情",
          // keepAlive:true
        },
        // beforeEnter: (to, from, next) => {
        // //   (to),
        // ('线索详情');
        //   window.addEventListener('popstate', cancel, false);
        //   // ...
        //    remveBack()
        //     next()
        // },
      },
      {
        path: "/shareLink",
        name: "shareLink",
        components: {
          default: resolve => require(['../view/clueHome/shareLink'], resolve),
        },
        meta:{
          title:"销售线索",
          // keepAlive:true
        },
        // beforeEnter: (to, from, next) => {
        // //   (to),
        //   ('销售线索'),

        //   window.addEventListener('popstate', this.cancel, false);
        //   // ...
        //    remveBack()
        //     next()
        // },
      },
      {
        path: "/customerList",
        name: "customerList",
        components: {
          default: resolve => require(['../view/clueHome/customerList'], resolve),
        },
        meta:{
          title:"客户列表",
          // keepAlive:true
        }
      },
      {
        path: "/customerDetails",
        name: "customerDetails",
        components: {
          default: resolve => require(['../view/clueHome/customerDetails'], resolve),
        },
        meta:{
          title:"客户档案",
          // keepAlive:true
        }
      },
    //
    {
        path: '/lottery/details',
        name: '抽奖',
        component: resolve => require(['@/view/lottery'], resolve),
        meta: {
            title: '抽奖',
        }
    },
    {
        path: '/questionnaire/details',
        name: '问卷',
        component: resolve => require(['@/view/questionnaire'], resolve),
        meta: {
            title: '问卷',
        }
    },
    {
        path: '/joinQuestionnaire/details',
        name: '我参与的问卷',
        component: resolve => require(['@/view/joinQuestionnaire'], resolve),
        meta: {
            title: '我参与的问卷',
        }
    },
    {
        path: '/joinLottery/details',
        name: '我参与的抽奖',
        component: resolve => require(['@/view/joinLottery'], resolve),
        meta: {
            title: '我参与的抽奖',
        }
    },
    {
        path: '/createQuestionnaire/details',
        name: '我创建的问卷',
        component: resolve => require(['@/view/createQuestionnaire'], resolve),
        meta: {
            title: '我创建的问卷',
        }
    },
    {
        path: '/createLottery/details',
        name: '我创建的抽奖',
        component: resolve => require(['@/view/createLottery'], resolve),
        meta: {
            title: '我创建的抽奖',
        }
    },
    {
        path: '/questionnaireDetails/details',
        name: '问卷详情',
        component: resolve => require(['@/view/questionnaireDetails'], resolve),
        meta: {
            title: '问卷详情',
        }
    },
    {
        path: '/editQuestionnaire/details',
        name: '问卷编辑',
        component: resolve => require(['@/view/editQuestionnaire'], resolve),
        meta: {
            title: '问卷编辑',
        }
    },
    {
        path: '/newLottery/details',
        name: '发起抽奖',
        component: resolve => require(['@/view/newLottery'], resolve),
        meta: {
            title: '发起抽奖',
        }
    },
    {
        path: '/lotteryDetails/details',
        name: '抽奖详情',
        component:  resolve => require(['@/view/lotteryDetails'], resolve),
        meta: {
            title: '抽奖详情',
        }
    },
    {
        path: '/addressEdit/details',
        name: '地址',
        component: resolve => require(['@/view/addressEdit'], resolve),
        meta: {
            title: '地址',
        }
    },
    {
        path: '/previewQuestionnaire/details',
        name: '问卷预览',
        component: resolve => require(['@/view/previewQuestionnaire'], resolve),
        meta: {
            title: '问卷预览',
        }

    },
    // {
    //     path: '/mine',
    //     name: '个人中心',
    //     component: mine
    // },
    {
        path: '/orderList/details',
        name: '订单',
        components: {
            default: resolve => require(['../view/product/orderList'], resolve),
        },
        meta: {
            title: '订单',
        }
    },
    {
        path: '/myInfo',
        name: '个人信息',
        components: {
            default: resolve => require(['../view/mine/myInfo'], resolve),
        },
        meta: {
            title: '个人信息',
        }
    },
    {
        path: '/createOrder/details',
        name: '创建订单',
        components: {
            default: resolve => require(['../view/product/createOrder'], resolve),
        },
        meta: {
            title: '创建订单',
        }
    },
    {
        path: '/createOrderT/details',
        name: '订单详情',
        components: {
            default: resolve => require(['../view/product/createOrder'], resolve),
        },
        meta: {
            title: '订单详情',
        }
    },
    {
        path: '/requireList/details',
        name: '需求',
        component: resolve => require(['@/view/requireList'], resolve),
        meta: {
            title: '需求',
        }
    },
    {
        path: '/releaseNeed/details',
        name: '发布需求',
        component: resolve => require(['@/view/releaseNeed'], resolve),
        meta: {
            title: '发布需求',
        }
    },
    {
        path: '/productDetails/details',
        name: '详情',
        components: {
            default: resolve => require(['../view/product/productDetails'], resolve),
        },
        meta: {
            title: '详情',
        }
    },
    {
        path: '/hotProduct/details',
        name: 'hotProduct',
        component: resolve => require(['@/view/hotProduct'], resolve),
        meta: {
            title: '推荐',
        }
    },
    {
        path: '/questionnaireResult/details',
        name: '问卷结果',
        component: resolve => require(['@/view/questionnaireResult'], resolve),
        meta: {
            title: '问卷结果',
        }
    },
    {
        path: '/tentative/details',
        name: '暂定',
        component: resolve => require(['@/view/tentative'], resolve),
        meta: {
            title: '暂定',
        }
    },
    {
        path: '/showBusiness',
        name: 'showBusiness',
        components: {
            default: resolve => require(['../view/product/showBusiness'], resolve),
        },
        meta: {
            title: '展开业务',
        }
    },
    {
        path: '/shareImg/details',
        name: '分享',
        component: resolve => require(['@/view/shareImg'], resolve),
        meta: {
            title: '分享',
        }
    },
    {
        path: '/productConsult/details',
        name: '咨询',
        component: resolve => require(['@/view/productConsult'], resolve),
        meta: {
            title: '咨询',
        }
    },
    {
        path: '/agent/details',
        name: '我推荐的经济人',
        component: resolve => require(['@/view/agentList'], resolve),
        meta: {
            title: '我推荐的经济人',
        }
    },
    {
        path: '/mine/details',
        name: '我的咨询',
        component: resolve => require(['@/view/qaList'], resolve),
        meta: {
            title: '我的咨询',
        }
    },
    {
        path: '/daySign',
        name: 'daySign',
        components: {
            default: resolve => require(['../view/daySign/daySign'], resolve),
        },
        meta: {
            title: '个人日签',
        }
    },
    {
        path: '/moreInviteType',
        name: 'moreInviteType',
        components: {
            default: resolve => require(['../view/mine/moreInviteType'], resolve),
        },
        meta: {
            title: '每日签到',
        }
    },
    {
        path: '/inviteFriends',
        name: '邀请好友',
        component: resolve => require(['@/view/mine/inviteFriends'], resolve),
        meta: {
            title: '邀请好友',
            keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/myFunds/details',
        name: '我的资金',
        component: resolve => require(['@/view/mine/myFunds'], resolve),
        meta: {
            title: '我的资金',
        }
    },
    {
        path: '/expected/details',
        name: '预期收入',
        component: resolve => require(['@/view/mine/expectedIncome'], resolve),
        meta: {
            title: '预期收入',
        }
    },
    {
        path: '/bankCard/details',
        name: 'bankCard',
        component: resolve => require(['@/view/mine/bankCard'], resolve),
        meta: {
            title: '银行卡绑定',
        }
    },
    {
        path: '/myAccount/details',
        name: '我的账户',
        component: resolve => require(['@/view/mine/bankCard'], resolve),
        meta: {
            title: '我的账户',
        }
    },
    {
        path: '/record/details',
        name: '提现记录',
        component: resolve => require(['@/view/mine/withdrawalsRecord'], resolve),
        meta: {
            title: '提现记录',
        }
    },

    {
        //实名认证调整为：手机号验证码，证件号姓名一起验证
        path: '/identityCheck',
        name: 'identityCheck',
        components: {
            // default: resolve => require(['../view/mine/identityCheck'], resolve),
            default: resolve => require(['@/view/loginNew/login'], resolve),
        },
        meta: {
            title: '实名认证',
        }
    },
    // {
    //     path: '/identityCheck/details',
    //     name: '实名认证',
    //     components: {
    //         default: resolve => require(['../view/identityCheck'], resolve),
    //     },
    //     meta: {
    //         title: '实名认证',
    //     }
    // },
    {
        path: '/editTitleDemo',
        name: '问卷编辑',
        component: resolve => require(['@/view/editTitleDemo'], resolve),
        meta: {
            title: '问卷编辑',
        }
    },
    {
        path: '/addQuestion',
        name: 'addQuestion',
        component: resolve => require(['@/view/addQuestion'], resolve),
        meta: {
            title: '问卷标题',
        }
    },
    {
        path: '/newQuestionnaire',
        name: '创建问卷',
        component: resolve => require(['@/view/newQuestionnaire'], resolve),
        meta: {
            title: '创建问卷',
        }
    },
    {
        path: '/newLotteryTitle',
        name: '创建抽奖',
        component: resolve => require(['@/view/newLotteryTitle'], resolve),
        meta: {
            title: '创建抽奖',
        }
    },
    {
        path: '/shareQuestionnaire',
        name: '分享',
        component: resolve => require(['@/view/shareQuestionnaire'], resolve),
        meta: {
            title: '分享',
        }
    },
    {
        //不走登录，直接调整到手机号和身份证验证
        path: '/login',
        name: '登录',
        components: {
            // default: resolve => require(['../view/login/login'], resolve),
            default: resolve => require(['@/view/loginNew/login'], resolve),
        },
        meta: {
            title: '登录',
        }
    },

    {
        path: '/audit',
        name: '实名认证',
        components: {
            default: resolve => require(['@/view/loginNew/login'], resolve),
        },
        meta: {
            title: '实名认证',
        }
    },

    {
        path: '/sasalink',
        name: 'sasalink',
        components: {
            default: resolve => require(['../viewTC/sasago/sasalink'], resolve),
        },
        meta: {
            title: '登录',
        }
    },
    {
        path: '/sasalogin',
        name: '登录',
        components: {
            default: resolve => require(['../viewTC/sasago/login'], resolve),
        },
        meta: {
            title: '登录',
        }
    },
    {
        path: '/sasabank',
        name: 'sasabank',
        components: {
            default: resolve => require(['../viewTC/sasago/bankCard'], resolve),
        },
        meta: {
            title: '绑定银行卡',
        }
    },
    {
        path: '/isLink',
        name: 'isLink',
        component: resolve => require(['@/view/isLink'], resolve),

    },
    {
        path: '/singleCreateOrder',
        name: '订单创建',
        component: resolve => require(['@/view/singleCreateOrder'], resolve),
        meta: {
            title: '创建订单',
        }
    },
    {
        path: '/adLink',
        name: '外部广告',
        component: resolve => require(['@/components/adLink'], resolve),
    },
    {
        path: '/moreArticles',
        name: 'moreArticles',//更多文章
        components: {
            default: resolve => require(['../view/home/moreArticles'], resolve),
        },
        meta: {
            title: '更多文章',
        }
    },
    // {
    //     path: '/article',
    //     name: '素材列表',
    //     components: {
    //         default: resolve => require(['../view/article/article'], resolve),
    //     },
    //     meta: {
    //         title: '素材列表',
    //     }
    // },
    {
        path: '/articleDetails',
        name: 'articleDetails',
        components: {
            default: resolve => require(['../view/articleHome/articleDetails'], resolve),
        },
        meta: {
            title: '文章详情',
        }
    },
    {
        path: '/articleGsc',
        name: '文章详情',
        components: {
            default: resolve => require(['../view/articleHome/articleGsc'], resolve),
        },
        meta: {
            title: '文章详情',
        }
    },
    {
        path: '/graphicDetails',
        name: '图文详情',
        components: {
            default: resolve => require(['../view/articleHome/graphicDetails'], resolve),
        },
        meta: {
            title: '图文详情',
        }
    },
    {
        path: '/content',
        name: 'content',
        components: {
            default: resolve => require(['../view/articleHome/content'], resolve),
        }
    },
    {
        path: '/search',
        name: '搜索页面',
        components: {
            default: resolve => require(['../view/articleHome/search'], resolve),
        },
        meta: {
            title: '搜索页面',
        }
    },
    {
        path: '/articleUpload',
        name: '文章上传',
        components: {
            default: resolve => require(['../view/articleHome/articleUpload'], resolve),
        }
    },
    {
        path: '/uploadedList',
        name: '我的文库',
        components: {
            default: resolve => require(['../view/articleHome/uploadedList'], resolve),
        },
        meta: {
            title: '我的文库',
        }
    },
    {
        path: '/video',
        name: 'video',
        components: {
            default: resolve => require(['../view/articleHome/video'], resolve),
        },
        meta: {
            title: '视频',
        }
    },
    {
        path: '/dialog',
        name: 'dialog',
        components: {
            default: resolve => require(['../view/chatBox/index'], resolve),
        },
        meta: {
            title: '对话框',
        }
    },

    // TC
    {
        path: '/productTC',
        name: 'tcContent',
        component: resolve => require(['@/componentsTC/tcContent'], resolve),
        children: [
            {
                path: '/productTC',
                name: 'productTC',
                component: resolve => require(['@/viewTC/productTC'], resolve),
            },
            {
                path: '/mineTC',
                name: 'mineTC',
                component: resolve => require(['@/viewTC/mine/index'], resolve),
            },
            {
                path: '/homeC',
                name: 'homeC',
                components: {
                    default: resolve => require(['@/viewTC/home/index'], resolve),
                },
                meta: {
                    title: '首页',
                }
            },
            {
                path: '/informationC',
                name: 'information',
                components: {
                    default: resolve => require(['../view/information/index'], resolve),
                },
                meta: {
                    title: '消息',
                    // keepAlive: true, // 需要被缓存
                }
            },
        ]
    },
    // 往下新界面 TC
    {
        path: '/info',
        name: 'info',
        components: {
            default: resolve => require(['../viewTC/mine/info'], resolve),
        },
        meta: {
            title: '个人信息',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/tobePay',
        name: 'tobePay',//
        components: {
            default: resolve => require(['@/view/kingWaiter/tobePay'], resolve),
        },
        meta: {
            title: '微信支付页面',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/order',
        name: 'order',
        components: {
            default: resolve => require(['../viewTC/mine/order'], resolve),
        },
        meta: {
            title: '我的订单',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/history',
        name: 'history',
        components: {
            default: resolve => require(['../viewTC/mine/browsingHistory'], resolve),
        },
        meta: {
            title: '个人收藏',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/myBroker',
        name: 'myBroker',
        components: {
            default: resolve => require(['../viewTC/mine/myBroker'], resolve),
        },
        meta: {
            title: '我的经纪人',
            // keepAlive: true, // 需要被缓存
        }
    },
    // 往上新界面  TC
    {
        path: '/articleDetailsC',//文章详情
        name: 'articleDetailsC',
        components: {
            default: resolve => require(['@/viewTC/home/articleDetails'], resolve),
        },
        meta: {
            title: '',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/moreArticlesC',//文章
        name: 'moreArticlesC',
        components: {
            default: resolve => require(['@/viewTC/home/moreArticles'], resolve),
        },
        meta: {
            title: '',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/orderList/detailsTC',
        name: '订单',
        components: {
            default: resolve => require(['@/viewTC/orderListTC'], resolve),
        },
        meta: {
            title: '订单',
        }
    },
    {
        path: '/sharePage',//分享跳转空白页
        name: 'sharePage-in',
        components: {
            default: resolve => require(['@/viewTC/sharePage'], resolve),
        },
        meta: {
            title: '',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/delistedProducts',//下架产品
        name: 'delistedProducts',
        components: {
            default: resolve => require(['@/viewTC/delistedProducts'], resolve),
        },
        meta: {
            title: '产品下架',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/otherDetails',//三个产品详情页
        name: 'otherDetails',
        components: {
            default: resolve => require(['@/viewTC/other/otherDetails'], resolve),
        },
        meta: {
            title: '产品',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/lufax',//三个产品详情页
        name: 'lufax',
        components: {
            default: resolve => require(['@/viewTC/lufax'], resolve),
        },
    },
    {
        path: '/ocft',
        name: 'ocft',//我的
        components: {
            default: resolve => require(['@/viewTC/ocft'], resolve),
        },
        meta: {
            title: '客户录单',
            // keepAlive: true, // 需要被缓存
        }
    },

    {
        path: '/simulate',
        name: 'simulate',//我的
        components: {
            default: resolve => require(['@/view/simulate/login'], resolve),
        },
        meta: {
            title: '模拟登录',
            // keepAlive: true, // 需要被缓存
        }
    },
    // sass
    {
        path: '/useAgreement',
        name: 'useAgreement',//
        components: {
            default: resolve => require(['@/view/sass/useAgreement'], resolve),
        },
        meta: {
            title: '使用协议',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/sassLogin',
        name: 'sassLogin',//
        components: {
            default: resolve => require(['@/view/sass/login'], resolve),
        },
        meta: {
            title: '登录',
            keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/tobePaid',
        name: 'tobePaid',//
        components: {
            default: resolve => require(['@/view/sass/tobePaid'], resolve),
        },
        meta: {
            title: '支付列表',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/paidDetails',
        name: 'paidDetails',//
        components: {
            default: resolve => require(['@/view/sass/paidDetails'], resolve),
        },
        meta: {
            title: '订单详情',
            // keepAlive: true, // 需要被缓存
        }
    },
    // sass
    {
        path: '/myCustomer',
        name: 'myCustomer',//
        components: {
            default: resolve => require(['@/view/customer/myCustomer'], resolve),
        },
        meta: {
            title: '我的客户',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/customerArchives',
        name: 'customerArchives',//
        components: {
            default: resolve => require(['@/view/customer/customerArchives'], resolve),
        },
        meta: {
            title: '客户档案',
            // keepAlive: true, // 需要被缓存
        }
    },
    {
        path: '/insuranceDetails',
        name: 'insuranceDetails',//
        components: {
            default: resolve => require(['@/view/product/insuranceDetails'], resolve),
        },
        meta: {
            title: '保险明细',
            // keepAlive: true, // 需要被缓存
        }
    },
]
const router = new VueRouter({
    // mode: 'history',
    // base: process.env.BASE_URL,
    routes
})

export default router
